import { IPlatformSpecificInfo, platforms } from "./../../../constants/platform";
import { getEnvironmentBaseUrl } from "./get-environment";

const findPlatformContent = (platformId: number): IPlatformSpecificInfo => {
  const platform = getPlatform(platformId);
  const url = getPlatformUrl(platformId);

  return {
    ...platform,
    url
  } as IPlatformSpecificInfo;
};

const getPlatform = (platformId: number): IPlatformSpecificInfo =>
  platforms.find((p) => p.id === platformId) as IPlatformSpecificInfo;

const getPlatformUrl = (platformId: number) => {
  const platform = getPlatform(platformId);

  const baseUrl = `${getEnvironmentBaseUrl()}${platform.domain}`;

  return [baseUrl, platform.urlAddition].filter(Boolean).join("/");
};

/**
 * Absolute URL of the current page. `pageUrl` is the raw request path and already contains the
 * platform's url-addition (`/fr/magasins/bol/` on BEFR), so the host is built without it —
 * `getPlatformUrl` appends that segment and would double it.
 */
const getAbsolutePageUrl = (platformId: number, pageUrl: string): string =>
  `${getEnvironmentBaseUrl()}${getPlatform(platformId).domain}${pageUrl}`;

export { findPlatformContent, getPlatformUrl, getAbsolutePageUrl };
